var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZxxf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1740641238575,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 10291,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1011.1 73.9c16.6 15.9 17.2 42.1 1.4 58.8L632.6 530.8c-7.9 8.3-18.7 12.9-30 12.9-10.6 0-20.9-4.1-28.7-11.5-7.9-7.5-12.6-18-12.8-29.1-0.3-11.1 3.9-21.8 11.5-29.7L952.4 75.2c16-16.6 41.9-17.2 58.7-1.3z",
    "p-id": 10292,
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M851.2 564.7c0-19.5 16.7-35.4 37.3-35.4s37.3 15.8 37.3 35.4v251.4c0 114-97.7 206.6-217.9 206.6h-490C97.7 1022.7 0 930 0 816.1V207.9C0 94 97.7 1.3 217.9 1.3h535.9c20.6 0 37.3 15.8 37.3 35.4s-16.7 35.4-37.3 35.4H217.9c-79 0-150.3 60.9-150.3 135.8v608.2C67.6 891 139 952 218 952h490c79 0 143.2-60.9 143.2-135.8V564.7z",
    "p-id": 10293,
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M364.2 407.5v94.7c0 17.9-14.3 32.3-31.9 32.3-8.4 0.1-16.5-3.3-22.4-9.4-6-6.1-9.4-14.3-9.4-22.9v-94.7h-89.7c-17.7 0.1-32.2-14.5-32.4-32.8 0-18.1 14.5-32.8 32.4-32.8h89.6v-81.1c0-17.9 14.3-32.3 31.9-32.3s31.9 14.5 31.9 32.3v81.1h92.5c17.9 0 32.4 14.6 32.4 32.8 0 18.1-14.5 32.8-32.4 32.8h-92.5z",
    "p-id": 10294,
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZxxf);
export default __webpack_public_path__ + "static/media/zxxf.bf785ba3.svg";
export { ForwardRef as ReactComponent };